import { useState } from 'react';

import { cn } from '@/lib/utils';

interface ArtistAvatarProps {
  name: string;
  src?: string | null;
  className?: string;
}

/** Shows the artist's avatar media, falling back to their initial. */
export function ArtistAvatar({ name, src, className }: ArtistAvatarProps) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={cn(
        'flex items-center justify-center overflow-hidden rounded-full bg-muted font-medium text-xs',
        className,
      )}
    >
      {src && !failed ? (
        <img
          src={src}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        name.slice(0, 1)
      )}
    </div>
  );
}
